class BlockTestimonials {
	constructor($block, Swiper) {
		this.$block = $block;
		this.$swiperContainer = this.$block.find('.swiper-container').first();

		this.swiperInstance = new Swiper(this.$swiperContainer.get(0), {
			speed: 400,
			slidesPerView: 'auto',
			direction: 'horizontal',
			navigation: {
				prevEl: this.$block.find('.swiper-button-prev').first().get(0),
				nextEl: this.$block.find('.swiper-button-next').first().get(0)
			},
			loop: true,
			autoHeight: true
		});
	}
}

export default BlockTestimonials;
